import { useMemo } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_EVENTS } from '../shared-values.model';
import { waitForNext } from '../../operators';
export function useSharedStoreEventsContext(values) {
    return useMemo(function () { return new SharedStoreEventsContext(values); }, [values]);
}
var NoOpCriteria = function () { return true; };
var SharedStoreEventsContext = /** @class */ (function () {
    function SharedStoreEventsContext(context) {
        this.context = context;
    }
    SharedStoreEventsContext.prototype.waitForNext = function (event, filter) {
        var criteria = filter || NoOpCriteria;
        var stream = this.stream(event);
        return firstValueFrom(stream.pipe(waitForNext(criteria)));
    };
    SharedStoreEventsContext.prototype.on = function (event, listener) {
        var stream = this.stream(event);
        var sub = stream.subscribe(listener);
        return function () { return sub.unsubscribe(); };
    };
    SharedStoreEventsContext.prototype.stream = function (eventType) {
        var stream = this.context.get(APP_EVENTS, eventType);
        return stream.pipe(map(function (event) { return event.payload; }));
    };
    SharedStoreEventsContext.prototype.dispatch = function (type, payload) {
        var stream = this.context.get(APP_EVENTS, type);
        unstable_batchedUpdates(function () { return stream.next({ type: type, payload: payload }); });
    };
    return SharedStoreEventsContext;
}());
export { SharedStoreEventsContext };
//# sourceMappingURL=events-context.js.map